import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_promotion_draw_details: { message: "idle" },
};

export const retrieve_promotion_draw_details_Slice = createSlice({
 name: "retrieve_promotion_draw_details",
 initialState,
 reducers: {
  success_retrieve_promotion_draw_details: (state, action) => {
   state.retrieve_promotion_draw_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_promotion_draw_details: (state, action) => {
   state.retrieve_promotion_draw_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_promotion_draw_details: (state) => {
   state.retrieve_promotion_draw_details = { status: app_consts.IDLE };
  },
  loading_retrieve_promotion_draw_details: (state) => {
   state.retrieve_promotion_draw_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_promotion_draw_details, fail_retrieve_promotion_draw_details, reset_retrieve_promotion_draw_details, loading_retrieve_promotion_draw_details } = retrieve_promotion_draw_details_Slice.actions;

export default retrieve_promotion_draw_details_Slice.reducer;